var React = require('react');

function ArrowV2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"a","d":"M9.466.362a.935.935,0,0,1,1.477,0l9.278,12.173a.9.9,0,0,1-.185,1.265.941.941,0,0,1-1.292-.181L10.2,2.41,1.665,13.619A.927.927,0,0,1,.372,13.8a.883.883,0,0,1-.185-1.265Z","transform":"translate(0 20.404) rotate(-90)"}));
}

ArrowV2.defaultProps = {"width":"13.984","height":"20.404","viewBox":"0 0 13.984 20.404"};

module.exports = ArrowV2;

ArrowV2.default = ArrowV2;
